"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.tabs.threads': 'Threads',
    'whatsapp.tabs.settings': 'Settings',
    'whatsapp.tabs.groups': 'Groups',
    'whatsapp.tabs.directMessages': 'Direct Messages',
    'whatsapp.tabs.email': 'Email',
    'whatsapp.tabs.emailSettings': 'Email Settings',
};
